import React, { useState, useEffect } from 'react';
import { getEnrolments, auditEnrolments } from '../database';
import RegistrationTable from './RegistrationTable';

function ListEnrolments() {
    const [enrolments, setEnrolments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [missingEnrolments, setMissingEnrolments] = useState([]);
    const [isAuditing, setIsAuditing] = useState(false);
    const [secretCode, setSecretCode] = useState('');

    useEffect(() => {
        loadEnrolments();
    }, []);

    const loadEnrolments = async () => {
        try {
            setLoading(true);
            const snapshot = await getEnrolments();
            const enrolmentData = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setEnrolments(enrolmentData);
            setError(null);
        } catch (err) {
            setError('Failed to load enrolments: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleAudit = async () => {
        try {
            setIsAuditing(true);
            const missing = await auditEnrolments();
            setMissingEnrolments(missing);
            if (missing.length === 0) {
                alert('Audit complete: All enrolments are present!');
            }
        } catch (err) {
            setError('Audit failed: ' + err.message);
        } finally {
            setIsAuditing(false);
        }
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div className="error">{error}</div>;

    if (secretCode !== 'ElpisIsrael') {
        return (
            <div className="p-4">
                <h2 className="text-xl font-bold mb-4">Enter Secret Code</h2>
                <div className="flex items-center gap-2">
                    <input
                        type="password"
                        value={secretCode}
                        onChange={(e) => setSecretCode(e.target.value)}
                        placeholder="Enter secret code"
                        className="border p-2 rounded"
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="enrolments-container">
            <div className="mb-4 flex justify-between items-center">
                <h2 className="text-xl font-bold">Current Enrolments</h2>
                <button
                    onClick={handleAudit}
                    disabled={isAuditing}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                    {isAuditing ? 'Auditing...' : 'Audit Enrolments'}
                </button>
            </div>

            {missingEnrolments.length > 0 && (
                <div className="mb-4 p-4 bg-red-100 border border-red-400 rounded">
                    <h3 className="text-lg font-bold text-red-700 mb-2">
                        Missing Enrolments
                    </h3>
                    <p className="mb-2">
                        The following enrolments are in the logs but not in the
                        database:
                    </p>
                    <ul className="list-disc pl-5">
                        {missingEnrolments.map((enrolment) => (
                            <li
                                key={`${enrolment.documentId}-${enrolment.timestamp}`}
                                className="text-red-600 mb-4"
                            >
                                {enrolment.firstName} {enrolment.lastName} (
                                {enrolment.email})
                                <br />
                                <span className="text-sm text-gray-600">
                                    Registered:{' '}
                                    {new Date(
                                        enrolment.timestamp
                                    ).toLocaleString()}
                                    <br />
                                    Document ID: {enrolment.documentId}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            <RegistrationTable enrolments={enrolments} />
        </div>
    );
}

export default ListEnrolments;
